import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { loadingStart, loadingStop, login } from 'redux/action';
import { toast } from 'react-toastify';
import { DashboardContainer } from 'components';
import Body from './Body';
import API from 'services/api';

const Index = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [planDetails, setPlanDetails] = useState(null);

  const updatePlanDetails = (key, value) => {
    setPlanDetails((state) => {
      return {
        ...state,
        [key]: value
      };
    });
  };

  const createPlan = async () => {
    dispatch(loadingStart());
    // let planCode = (newPlanDetails.name || '').replace(/[^a-z0-9]/gi, '');
    await API.createPlan(planDetails)
      .then((response) => {
        if (response) {
          toast.success('Plan Successfully Created!');
          navigate('/plan-list');
        }
      })
      .finally(() => {
        dispatch(loadingStop());
      });
  };

  return (
    <DashboardContainer>
      <Body
        _this={{
          planDetails,
          updatePlanDetails,
          createPlan
        }}
      />
    </DashboardContainer>
  );
};

export default Index;
